import FlickrUtils from "@/utils/FlickrUtils";
import FeatureServiceUtils from "@/utils/FeatureServiceUtils";

export default {
    namespaced: true,

    state: {
        items: [],
        constructionCameras: []
    },

    actions: {
        initialize({dispatch}) {
            console.info('Home module initializing...')
            dispatch('getItems')
            dispatch('getConstructionCameras')
            console.info('Home module initialized.')
        },

        getItems({commit}) {
            FlickrUtils.getPhotos().then(data => {
                commit('setItems', {items: data})
            })
        },

        getConstructionCameras({commit}) {
            FeatureServiceUtils.getConstructionCamers().then(data => {
                commit('setConstructionCameras', {items: data})
            })
        }
    },

    mutations: {
        setItems(state, payload) {
            state.items = payload.items
        },
        setConstructionCameras(state, payload) {
            state.constructionCameras = payload.items
        }
    }
}
